import api from '@/services/api';

export async function listTickets(params = {}) {
  const res = await api.get('/tickets', { params });
  return res.data;
}

export async function getTicket(id) {
  const res = await api.get(`/tickets/${encodeURIComponent(id)}`);
  return res.data;
}

export async function createTicket({ subject, message, attachments = [], isPrivate = false }) {
  const form = new FormData();
  form.append('subject', subject);
  if (message) form.append('message', message);
  // Backend akzeptiert "private" oder "is_private"
  form.append('private', isPrivate ? '1' : '0');
  (attachments || []).forEach((f) => form.append('files[]', f));
  const res = await api.post('/tickets', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data; // { id: number }
}

export async function postMessage(ticketId, { message, attachments = [] }) {
  const form = new FormData();
  form.append('message', message);
  (attachments || []).forEach((f) => form.append('files[]', f));
  const res = await api.post(`/tickets/${encodeURIComponent(ticketId)}/messages`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
}

export async function updateTicketStatus(ticketId, status) {
  const res = await api.patch(`/tickets/${encodeURIComponent(ticketId)}/status`, { status });
  return res.data;
}

export async function downloadTicketAttachment(ticketId, documentId) {
  return api.get(
    `/tickets/${encodeURIComponent(ticketId)}/attachments/${encodeURIComponent(documentId)}`,
    { responseType: 'blob' }
  );
}

export async function getTicketAttachmentBase64(ticketId, documentId) {
  const res = await api.get(
    `/tickets/${encodeURIComponent(ticketId)}/attachments/${encodeURIComponent(documentId)}/base64`,
    { responseType: 'json' }
  );
  return res.data; // { base64, mimeType, filename }
}

export async function getTicketsUnreadCount() {
  const res = await api.get('/tickets/unread-count', { responseType: 'json' });
  return res.data; // { count }
}

export async function getTicketsUnreadMap() {
  const res = await api.get('/tickets/unread-map', { responseType: 'json' });
  return res.data; // { map: { [ticketId]: number } }
}

export async function markTicketAsRead(ticketId) {
  const res = await api.post(`/tickets/${encodeURIComponent(ticketId)}/read`, {});
  return res.data; // { marked }
}
